import {
  Activity,
  AlertTriangle,
  AppWindow,
  ArrowLeft,
  BarChart3,
  Building2,
  Calendar,
  ChartLine,
  Check,
  CheckCircle,
  ChevronDown,
  Circle,
  ClipboardList,
  Code,
  Code2,
  Copy,
  Database,
  Download,
  FileText,
  Globe,
  Grid3x3,
  HardDrive,
  Headset,
  Kanban,
  KeyRound,
  Landmark,
  Layers,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Megaphone,
  MessageCircle,
  Pencil,
  PenTool,
  Plug,
  Plus,
  Search,
  SearchX,
  Settings,
  Share2,
  Shield,
  ShieldX,
  ShoppingCart,
  Terminal,
  Trash2,
  Unlink,
  User,
  UserPlus,
  Users,
  Workflow,
  Wrench,
  X,
  XCircle,
  Zap,
} from 'lucide-vue-next'

export const useIcons = () => {
  const icons = {
    'alert-triangle': AlertTriangle,
    'app-window': AppWindow,
    'arrow-left': ArrowLeft,
    'building-2': Building2,
    'calendar': Calendar,
    'bar-chart-3': BarChart3,
    'chart-line': ChartLine,
    'check-circle': CheckCircle,
    'check': Check,
    'chevron-down': ChevronDown,
    'circle': Circle,
    'clipboard-list': ClipboardList,
    'code': Code,
    'code-2': Code2,
    'copy': Copy,
    'database': Database,
    'download': Download,
    'file-text': FileText,
    'globe': Globe,
    'grid-3x3': Grid3x3,
    'hard-drive': HardDrive,
    'headset': Headset,
    'kanban': Kanban,
    'key-round': KeyRound,
    'landmark': Landmark,
    'layers': Layers,
    'lock': Lock,
    'log-in': LogIn,
    'log-out': LogOut,
    'mail': Mail,
    'megaphone': Megaphone,
    'message-circle': MessageCircle,
    'pen-tool': PenTool,
    'pencil': Pencil,
    'plug': Plug,
    'plus': Plus,
    'search-x': SearchX,
    'search': Search,
    'settings': Settings,
    'share-2': Share2,
    'shield': Shield,
    'shield-x': ShieldX,
    'shopping-cart': ShoppingCart,
    'terminal': Terminal,
    'trash-2': Trash2,
    'unlink': Unlink,
    'user-plus': UserPlus,
    'user': User,
    'users': Users,
    'workflow': Workflow,
    'wrench': Wrench,
    'x-circle': XCircle,
    'x': X,
    'activity': Activity,
    'zap': Zap,
  } as const

  const getIcon = (name: keyof typeof icons) => {
    return icons[name] || Circle
  }

  return {
    icons,
    getIcon,
  }
}